export default "__VITE_ASSET__1WZ9FMQs__"